import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private snackBar = inject(MatSnackBar);

  showSnackBar(data: {
    message: string;
    messageParams?: object;
    action?: string;
    actionParams?: string;
    duration?: number;
  }) {
    this.snackBar
      .open(data.message, data.action ?? undefined, {
        duration: data.duration ?? 3000,
        panelClass: 'snackbar',
      })
      .onAction();
  }
}
